import Request from "../Request.js";

const FFSOLAR_SERVER_URL = window.runtimeConfig?.FFSOLAR_SERVER_URL;
const annotations = {
  getAnnotations(projectId) {
    return Request.get(`${FFSOLAR_SERVER_URL}/projects/${projectId}/annotations`);
  },
  analyzeAnnotation(projectId, imageBase64) {
    return Request.post(`${FFSOLAR_SERVER_URL}/annotations/prediction`, {
      project_id: Number(projectId),
      imageBase64: imageBase64,
    });
  },
  deleteAnnotation(annotationId) {
    return Request.delete(`/annotations/${annotationId}/`);
  },
  saveAnnotation(projectId, imagePk, data) {
    return Request.post(`${FFSOLAR_SERVER_URL}/annotations`, {
      project_id: Number(projectId),
      image_id: imagePk,
      damage_type: data.damageType,
      severity_level: data.severityLevel,
      description: data.description,
      predicted_type: data.predictedType,
      predicted_severity_level: data.predictedSeverityLevel,
      predicted_description: data.predictedDescription,
      x: data.imgX,
      y: data.imgY,
      width: data.imgWidth,
      height: data.imgHeight,
      norm_x: data.normX,
      norm_y: data.normY,
      image_index: data.imageIndex,
    });
  },
};

export default annotations;
